<template>
    <section class="history-section" aria-label="取引履歴">
        <div class="history-toolbar">
            <h2>{{ $t('userWallet.history.title') }}</h2>
            <div class="history-toolbar-right">
                <a
                    class="staking-history-link"
                    :href="stakingHistoryUrl"
                    target="_blank"
                    rel="noopener noreferrer"
                >{{ $t('userWallet.history.stakingHistoryLink') }}</a>
                <div class="segmented-control" role="tablist" :aria-label="$t('userWallet.history.title')">
                    <button
                        v-for="tab in tabs"
                        :key="tab.currency"
                        type="button"
                        role="tab"
                        :class="{'is-active': activeCurrency === tab.currency}"
                        :aria-selected="activeCurrency === tab.currency"
                        @click="selectTab(tab.currency)"
                    >
                        {{ tab.label }}
                    </button>
                </div>
            </div>
        </div>

        <wallet-activity-list
            :loading="loading"
            :items="items"
            :pagination="pagination"
            :currency-symbol="activeCurrency"
            @change-page="fetchActivities"
        />
    </section>
</template>

<script>
    import UserWalletService from '../../../services/UserWalletService';
    import WalletActivityList from './WalletActivityList.vue';
    import {CURRENCIES, historyEnabledCurrencies} from '../constants/currencies.js';

    export default {
        name: 'WalletHistorySection',

        components: {
            WalletActivityList,
        },

        data() {
            return {
                activeCurrency: 'ETH',
                loading: false,
                items: [],
                pagination: {total_pages: 0, current_page: 1, per_page: 20, total: 0},
                stakingHistoryUrl: `${process.env.MIX_AUBE_COIN_STAKING_URL}/remittance-history`,
                requestSeq: 0,
            };
        },

        computed: {
            tabs() {
                return historyEnabledCurrencies().map((symbol) => ({
                    currency: symbol,
                    label: CURRENCIES[symbol].name,
                }));
            },
        },

        created() {
            this.fetchActivities();
        },

        methods: {
            refresh(spinner = true) {
                this.pagination.current_page = 1;
                this.fetchActivities(spinner);
            },

            selectTab(currency) {
                if (this.activeCurrency === currency) {
                    return;
                }
                this.activeCurrency = currency;
                this.items = [];
                this.pagination.current_page = 1;
                this.fetchActivities();
                this.$emit('tab-change', currency);
            },

            /**
             * spinner = false is a background refetch (refresh after a transfer/claim completes).
             * Keep the current rows on screen instead of raising `loading`: behind the completion
             * modal, collapsing the list into an empty loading row reads as a second load.
             */
            async fetchActivities(spinner = true) {
                this.loading = spinner;
                this.requestSeq += 1;
                const requestSeq = this.requestSeq;
                const fetchedCurrency = this.activeCurrency;
                const fetchedPage = this.pagination.current_page;
                try {
                    const response = await UserWalletService.getWalletActivities({
                        currency: this.activeCurrency,
                        page: this.pagination.current_page,
                        perPage: this.pagination.per_page,
                        spinner,
                    });
                    if (requestSeq !== this.requestSeq) {
                        return;
                    }
                    this.items = response.data.items;
                    this.pagination = response.data.pagination;
                } catch (e) {
                    if (requestSeq !== this.requestSeq) {
                        return;
                    }
                    this.items = [];
                } finally {
                    if (requestSeq === this.requestSeq) {
                        this.loading = false;
                        if (fetchedCurrency === 'ETH' && fetchedPage === 1) {
                            this.$emit('activities-loaded');
                        }
                    }
                }
            },
        },
    };
</script>
